<template>
  <div
    class="bottom-player"
    :class="{
      'bottom-player-show': renderData.curPlayData,
      'bottom-player-hide': !renderData.curPlayData,
    }"
  >
    <div class="audio-item-cover">
      <img
        :src="
          renderData.curPlayData?.cover
            ? getObjectStorageFullUrl(renderData.curPlayData?.cover)
            : defaultCover
        "
      ></img>
    </div>
    <div class="audio-item-info">
      <!-- <div style="color: #fff; font-size: 12px; margin-bottom: 4px">{{ renderData.url }}</div> -->
      <div class="audio-item-title-version">
        <div class="audio-item-title pointer olh" @click="handleDetail">
          {{ renderData.curPlayData?.title ?? "" }}
        </div>
        <!-- <div class="audio-item-version">V1</div> -->
      </div>
      <div class="audio-item-decription flex">
        <div class="audio-item-decription-content olh">
          {{
            `${
              getNakeName(renderData.curPlayData, "user.stage_name") ??
              userDataStore.userInfo?.user?.stage_name
            }`
          }}
          {{
            !renderData.isGenerating &&
            (renderData.curPlayData?.description?.trim() ||
              (!renderData.curPlayData?.description &&
                combineStrings(
                  renderData.curPlayData?.genres,
                  renderData.curPlayData?.moods
                )))
              ? " - " +
                (renderData.curPlayData?.description?.trim() ||
                  combineStrings(
                    renderData.curPlayData?.genres,
                    renderData.curPlayData?.moods
                  ))
              : ""
          }}
          <!-- {{
            !props.isGenerating &&
            (renderData.curPlayGroup?.startsWith("feedlist")
              ? $$language() != "cn"
              : $$language() == "cn"
              ? (!renderData.curPlayData?.uid &&
                  renderData.curPlayData?.uid !=
                    userDataStore?.userInfo?.user?.user_id) ||
                !!renderData.curPlayData?.state ||
                !!renderData.curPlayData?.sold_state
              : true)
              ? 
              combineStrings(
                  renderData.curPlayData?.genres,
                  renderData.curPlayData?.moods
                )
                ? " - " +
                  combineStrings(
                    renderData.curPlayData?.genres,
                    renderData.curPlayData?.moods
                  )
                : ""
              : ""
          }} -->
          {{ renderData.isGenerating ? " - " : "" }}
        </div>
        <!-- {{ formatTime(renderData.curPlayData?.created_on ?? new Date()) }} -->

        <span class="rotate-loading block" v-if="renderData.isGenerating">
        </span>
      </div>
    </div>

    <div class="audio-palyer-controls flex1 width-0">
      <div class="audio-palyer-controls-box">
        <GlobalPlayer
          :highPosition="
            renderData.curPlayData?.is_regenerate
              ? renderData.curPlayData?.regenerate_from / 1000
              : null
          "
          ref="refGlobalPlayer"
          :url="renderData.url"
          :duration="renderData.duration"
          @switch="doSwitch"
          @syncPlayState="doSyncPlayState"
          @curPlayEnded="onCurPlayEnded"
          :perContinuousPlaybackTimeCallback="
            onPerContinuousPlaybackTimeCallback
          "
          v-model:isGenerating="renderData.isGenerating"
        >
          <!-- <template v-slot:playlist>
            <div
              class="global-player-playlist global-player-ico-btn pointer fn-inline"
            >
              <i class="block"></i>
            </div>
          </template> -->
        </GlobalPlayer>
      </div>
    </div>
    <div class="audio-palyer-right" >
     <div class="audio-palyer-right-contennt flex" v-if="!globalPlayDataStore.curPlayGroup?.startsWith('tts_')">
      <Bubble
        :disabled="isDisableByAudit()"
        :content="
          renderData.curPlayData?.is_liked == 1 && renderData.curPlayData?.is_disliked != 1
            ? $$t('editor.unlike')
            : $$t('editor.like')
        "
        position="top"
      >
        <div
          class="audio-item-like-status audio-item-ico-btn ico-btn pointer flex-center"
          :class="{
            disabled: isDisableByAudit(),
          }"
          @click="
            () => {
              if (!isDisableByAudit()) {
                doLike()
              }
            }
          "
        >
          <i
            class="block"
            :class="{
              'like-true':
                renderData.curPlayData?.is_liked == 1 &&
                renderData.curPlayData?.is_disliked != 1,
            }"
          ></i>
        </div>
      </Bubble>
      <Bubble
        :disabled="isDisableByAudit()"
        :content="
          renderData.curPlayData?.is_disliked == 1 &&
          renderData.curPlayData?.is_liked != 1
            ? $$t('editor.undislike')
            : $$t('editor.dislike')
        "
        position="top"
      >
        <div
          class="audio-item-dislike-status audio-item-ico-btn ico-btn pointer flex-center"
          :class="{
            disabled: isDisableByAudit(),
          }"
          @click="
            () => {
              if (!isDisableByAudit()) {
                doDislike()
              }
            }
          "
        >
          <i
            class="block"
            :class="{
              'like-false':
                renderData.curPlayData?.is_disliked == 1 &&
                renderData.curPlayData?.is_liked != 1,
            }"
          ></i>
        </div>
      </Bubble>
      <Bubble
        :content="$$t('store.copyLink')"
        position="top"
        :disabled="isDisableByAudit()"
        v-model:successContent="renderData.shareSuccessText"
      >
        <div
          class="audio-item-share audio-item-ico-btn ico-btn pointer flex-center"
          :class="{
            disabled: isDisableByAudit(),
          }"
          @click="
            () => {
              if (!isDisableByAudit()) {
                doShare()
              }
            }
          "
        >
          <i class="block"></i>
        </div>
      </Bubble>
      <template
        v-if="
          renderData.curPlayGroup == 'storeList' ||
          renderData.curPlayGroup == 'cartList' ||
          renderData.curPlayGroup == 'likedList' ||
          renderData.curPlayGroup == 'storeDetail'
        "
      >
        <!-- <Bubble
          :content="$$t('store.addCart')"
          position="top"
          v-if="
            renderData.curPlayData?.sold_state == 1 &&
            renderData.curPlayData?.audit_state == 1
          "
        >
          <div
            class="audio-item-buy audio-item-ico-btn ico-btn pointer flex-center"
            :class="
              renderData.curPlayData?.uid == userDataStore?.authData?.user_id
                ? 'op'
                : ''
            "
            @click="
              doAddToShoppingCart(
                renderData.curPlayData?.uid == userDataStore?.authData?.user_id
              )
            "
          >
            <i
              class="block"
              :class="{
                'cart-true': renderData.curPlayData?.cart_state == 1,
                'cart-false': renderData.curPlayData?.cart_state != 1,
              }"
            ></i>
          </div>
        </Bubble>
        <div
          class="audio-item-btn audio-item-btn1"
          :class="
            renderData.curPlayData?.uid == userDataStore?.authData?.user_id
              ? 'op'
              : ''
          "
          v-if="
            renderData.curPlayData?.sold_state == 1 &&
            renderData.curPlayData?.audit_state == 1
          "
        >
          <Button
            @click="
              doCheckout(
                renderData.curPlayData?.uid == userDataStore?.authData?.user_id
              )
            "
            class="flex-center"
            :renderStyle="{
              '--padding': '0',
              '--width': '100px',
              '--height': '32px',
              '--borderRadius': '50px',
              '--background': 'rgba(255, 255, 255, 0.2)',
              '--fontColor': '#fff',
              '--fontSize': '14px',
              '--fontWeight': 'normal',
              '--border': 'none',
            }"
            >{{ $$t("store.checkout") }}</Button
          >
        </div> -->
        <div
          v-if="
            $$language() == 'cn' &&
            renderData.curPlayData?.sold_state == 1 &&
            renderData.curPlayData?.audit_state == 1
          "
          class="audio-item-ico-btn ico-btn pointer flex-center"
        >
          <Report @handleReport="handleReport"></Report>
        </div>
      </template>
      </div>
    </div>
  </div>
  <ReportDialog
    v-if="reportDialogVisible"
    v-model:visible="reportDialogVisible"
    :data="renderData.curPlayData"
    :reportType="4"
  ></ReportDialog>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  reactive,
  watch,
  onMounted,
  getCurrentInstance,
} from "vue"
import { useRouter } from "vue-router"
import constTags from "@/config/const.js"

import defaultCover from "/assets/default-cover-3x.png"


import GlobalPlayer from "@/components/media/audioPlayer/GlobalPlayer.vue"
import Bubble from "@/components/bubble/bubble.vue"
import Report from "@/components/report/report.vue"
import ReportDialog from "@/components/report/reportDialog.vue"

import message from "@/components/functionCallComponent/message/message.js"
import { getObjectStorageFullUrl } from "@/lib/objectStorage/objectStorage.js"
import useGlobalPlayDataStore, {
  curPlayGroupPlayPointMap,
} from "@/store/globalPlayDataStore.js"
import tools from "@/utils/tools.js"
import useUserDataStore from "@/store/userDataStore"
import useShopCartStore from "@/store/shopCartStore.js"
import useFeedListStore from "@/store/create/feedListDataStore.js"

import { formatDateTime } from "@/utils/dateTime.js"
import feedListApi from "@/api/api/feedListApi.js"
import {
  getGuidanceJsonDataUrl,
  ModuleOpenStateControl,
  getPipeReadableFlowUrl,
} from "@/config/config.js"
const globalProperties =
  getCurrentInstance()?.appContext.config.globalProperties
const { $$t, $$language } = globalProperties?.$i18n ?? {};
const userDataStore = useUserDataStore()
const globalPlayDataStore = useGlobalPlayDataStore()
const shopCartStore = useShopCartStore()
const feedListDataStore = useFeedListStore()

const appContext = getCurrentInstance()?.appContext

const formatData = (timestamp) => {
  return formatDate(timestamp, "YYYY-MM-DD hh:mm")
  // return formatDateTime(timestamp);
}

const getNakeName = (item, itemIdField) => {
  return (
    tools.getDataByFields(item, itemIdField) ||
    (userDataStore.userInfo?.user?.stage_name ?? "")
  )
}

const combineStrings = (str1, str2) => {
  if (!(Array.isArray(str1) && Array.isArray(str2))) return
  if (str1 && str2) {
    return `${str1.join(" ")} | ${str2.join(" ")}`
  }
  return str1?.join(" ") || str2?.join(" ")
  // return str1?.join(" ") || str2?.join(" ");
  // // str1 =>genres str2 => moods
  // const genres = constTags.getRenderLabel(str1, constTags.StyleLabelData.map, $$language());
  // const moods = constTags.getRenderLabel(
  //   str2,
  //   constTags.EmotionalLabelData.map,
  //   $$language()
  // );
  // if (genres?.length && moods?.length) {
  //   return `${genres.join(" ")} | ${moods.join(" ")}`;
  // } else if (genres?.length) {
  //   return genres.join(" ");
  // } else if (moods?.length) {
  //   return moods.join(" ");
  // } else {
  //   return "";
  // }
}

const props = defineProps({})
const emits = defineEmits([])
const router = useRouter()
const route = useRoute()
const refGlobalPlayer = ref(null)
const reportDialogVisible = ref(false)

const stateData = {
  lastReportSong_id: null,
}
const renderData = reactive({
  curPlayData: null,
  url: "",
  duration: 0,
  isPlaying: false,
  tempToggleStatus: false,
  curPlayGroup: null,
  shareSuccessText: "",
  isGenerating: false,
  lastPlaySong: null,
})

const isDisableByAudit = () => {
  //2-ing 3- chenggong 4-failed
  // int64 machine_audit_state = 11;
  return (
    [4, 5].includes(renderData.curPlayData?.machine_audit_state) ||
    [4].includes(renderData.curPlayData?.publish_state) ||
    renderData.curPlayData?.machine_audit_state == 4
  )
}
const handleDetail = () => {
  if(globalPlayDataStore.curPlayGroup?.startsWith("tts_")){
    return
  }
  if (route.name == "songDetail" || route.name == "songDetailOld") {
    router.replace({
      name: "songDetail",
      params: {
        source: "player",
        song_id: renderData.curPlayData?.song_id,
      },
      query: {
        ...(route.params?.from || route.query?.from
          ? { from: route.params?.from || route.query?.from }
          : {}),
      },
    })
  } else {
    router.push({
      name: "songDetail",
      params: {
        source: "player",
        song_id: renderData.curPlayData?.song_id,
      },
      query: {
        ...(route.params?.from || route.query?.from
          ? { from: route.params?.from || route.query?.from }
          : {}),
      },
    })
  }
}
const doPlayStateReport = (song_id, play_type) => {
  return new Promise((resolve, reject) => {
    feedListApi
      .doPlayStateReport({
        song_id: song_id,
        play_type: play_type,
      })
      .then((res) => {
        if (res.code == 200) {
          resolve()
        } else {
          reject(res?.msg ?? "save failed")
        }
      })
      .catch((e) => {
        reject(e)
      })
  })
}

const doSyncPlayState = (isPlaying) => {
  if (isPlaying) {
    globalProperties.logCustomEvent("single_song_play_click", {
      content_id: (renderData.curPlayData?.song_id ?? renderData.curPlayData?.id).toString(),
      duration: Number(renderData.duration).toFixed(2),
      start_position: Number(
        appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.players[
          renderData.url
        ]?.currentTime
      )
        .toFixed(2)
        .toString(),
      song_url: renderData.url,
      is_self:
        renderData.curPlayData?.uid == userDataStore?.authData?.user_id ? 1 : 0,
    })
  }
  renderData.isPlaying = isPlaying

  globalPlayDataStore.setIsPlaying(isPlaying)
  setTimeout(() => {
    if (renderData.isPlaying && renderData.curPlayData) {
      const song_id = renderData.curPlayData?.song_id
      if (!renderData.curPlayData?.is_played) {
        feedListDataStore
          .doReportPlayedState({}, renderData.curPlayData)
          .then(() => {
            if (song_id == renderData.curPlayData?.song_id) {
              renderData.curPlayData.is_played = true
            }
          })
      }
    }
  }, 100)
  if (
    renderData.isPlaying &&
    stateData.lastReportSong_id != renderData.curPlayData?.song_id
  ) {
    console.log("doSyncPlayState", "doPlayStateReport", 1)
    doPlayStateReport(renderData.curPlayData?.song_id, 1)
    if (curPlayGroupPlayPointMap[renderData.curPlayGroup]) {
      globalProperties.logClickEvent(
        curPlayGroupPlayPointMap[renderData.curPlayGroup],
        {
          content_id: renderData.curPlayData?.song_id,
        }
      )
    }
    stateData.lastReportSong_id = renderData.curPlayData?.song_id
  }
  let song_id = renderData.curPlayData?.song_id
  setTimeout(() => {
    if (
      song_id == renderData.curPlayData?.song_id &&
      !renderData.isPlaying &&
      !isPlaying
    ) {
      updatePipeReadableFlowUrl()
    }
  }, 10 * 60 * 1000)
}

const updatePipeReadableFlowUrl = async (isEnd = false, data) => {
  if (!globalPlayDataStore.curPlayData) return
  let isPlaying = isEnd && data?.player?.personalizedConfig?.loop
  if (
    renderData.curPlayData?.song_id ==
      globalPlayDataStore.curPlayData?.song_id &&
    /\.[0-9A-Za-z]{1,}$/.test(globalPlayDataStore.curPlayData?.mp3_url ?? "")
  ) {
    let url = renderData.url
    renderData.url = getObjectStorageFullUrl(
      globalPlayDataStore.curPlayData?.mp3_url
    )
    if (renderData.url != url) {
      renderData.duration =
        (globalPlayDataStore.curPlayData?.duration_milliseconds ?? 0) / 1000
      appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.registerPlayUrl(
        renderData.url,
        {
          currentTime: isEnd
            ? 0
            : appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.players[url]
                ?.currentTime ?? 0,
        }
      )
      if (isPlaying) {
        await appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.play(
          renderData.url
        )
        if (isEnd) {
          appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.seek(
            renderData.url,
            0
          )
        }
      }
      setTimeout(() => {
        globalPlayDataStore.updatePipeReadableFlowUrl(
          globalPlayDataStore.curPlayData
        )
      }, 10)
    }
  }
}

const onCurPlayEnded = (data) => {
  console.log("onCurPlayEnded", "doPlayStateReport", 1)
  doPlayStateReport(renderData.curPlayData?.song_id, 2)
  updatePipeReadableFlowUrl(true, data)
}
const onPerContinuousPlaybackTimeCallback = ({
  time,
  url,
  duration,
  startPosition,
}) => {
  console.log("onPerContinuousPlaybackTimeCallback", renderData.curPlayData)
  globalProperties.logCustomEvent("single_song_play_time", {
    content_id: (renderData.curPlayData?.song_id ?? renderData.curPlayData?.id).toString(),
    stay_time: Number(time).toFixed(2),
    duration: Number(duration).toFixed(2),
    start_position: Number(startPosition).toFixed(2),
    song_url: url,
    is_self:
      renderData.curPlayData?.uid == userDataStore?.authData?.user_id ? 1 : 0,
  })
}

const doSwitch = (data) => {
  globalPlayDataStore
    .switchSong(data)
    .then((curPlayData) => {
      setTimeout(async () => {
        // if (!renderData.isPlaying) {
        //   await appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.play(getAudioUrl(curPlayData));
        // }
        appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.seek(
          getAudioUrl(curPlayData),
          0
        )
      }, 10)
      if (route.name == "songDetail" || route.name == "songDetailOld") {
        router.replace({
          name: "songDetail",
          query: {
            ...(route.params?.from || route.query?.from
              ? { from: route.params?.from || route.query?.from }
              : {}),
          },
          params: {
            source: "switch",
            song_id: curPlayData?.song_id,
          },
        })
      } else {
        // router.push({
        //   name: "songDetail",
        //   query: {
        //     source: "switch",
        //   },
        //   params: {
        //     song_id: curPlayData?.song_id,
        //   }
        // });
      }
      globalPlayDataStore.updatePipeReadableFlowUrl(curPlayData)
    })
    .catch((e) => {
      console.error("doSwitch", e)
    })
}

const doLike = () => {
  // 处理点赞逻辑
  globalProperties.logClickEvent("song_like", {
    content_id:
      renderData.curPlayData?.song_id ??
      renderData.curPlayData?.song?.song_id ??
      "",
    tab_stare: "player",
    source: renderData.curPlayData?.is_liked == 1 ? 'cancel_like' : 'like',
  })
  globalPlayDataStore.doLike(renderData.curPlayData)
}

const doDislike = () => {
  // 处理取消点赞逻辑
  globalProperties.logClickEvent("song_unlike", {
    content_id:
      renderData.curPlayData?.song_id ??
      renderData.curPlayData?.song?.song_id ??
      "",
    tab_stare: "player",
    source: renderData.curPlayData?.is_disliked == 1 ? 'cancel_dislike' : 'dislike',
  })
  
  globalPlayDataStore.doDislike(renderData.curPlayData)
}

const doShare = () => {
  // 处理分享逻辑
  renderData.shareSuccessText = ""
  globalPlayDataStore.doShare(renderData.curPlayData).then((isSuccess) => {
    renderData.shareSuccessText = $$t("store.copyLinkSuccess")
    globalProperties.logClickEvent("song_copy_link", {
      content_id:
        renderData.curPlayData?.song_id ??
        renderData.curPlayData?.song?.song_id ??
        "",
      source: "player",
    })
  })
}

const doAddToShoppingCart = async (flag) => {
  // 处理加购物车逻辑
  if (flag) return
  if (!(await userDataStore.checkLoginStatus())) {
    return
  }
  globalPlayDataStore
    .doAddToShoppingCart(renderData.curPlayData)
    .then((res) => {
      if (res.code == 200) {
        const { buyType } = res
        globalProperties.logClickEvent("song_license_type_add_to_cart", {
          content_id: renderData.curPlayData?.song_id,
          type: buyType == 1 ? "Non-exclusive" : "Exclusive",
          source: "player",
        })
      }
    })
}

const doCheckout = async (flag) => {
  // 处理购买逻辑
  if (flag) return
  if (!(await userDataStore.checkLoginStatus())) {
    return
  }
  shopCartStore.doCheckout(renderData.curPlayData).then((res) => {
    if (!res) return
    if (res.code == 6305 || res.code == 6306) {
      globalPlayDataStore.updatePlayDataItem({
        ...renderData.curPlayData,
        sold_state: 4,
      })
      shopCartStore.deleteShopList(renderData.curPlayData?.id || 0)
    } else if (res.code == 200) {
      if (res.buyType != 1) {
        globalProperties.logClickEvent("song_license_type_checkout", {
          content_id: renderData.curPlayData?.song_id,
          type: "Exclusive",
          source: "player",
        })
        shopCartStore.deleteShopList(renderData.curPlayData?.id || 0)
        shopCartStore.updateShopCart(renderData.curPlayData?.song_id, 3)
        globalPlayDataStore.updatePlayDataItem({
          ...renderData.curPlayData,
          cart_state: 3,
          sold_state: 4,
        })
      } else {
        globalProperties.logClickEvent("song_license_type_checkout", {
          content_id: renderData.curPlayData?.song_id,
          type: "Non-exclusive",
          source: "player",
        })
        shopCartStore.updateShopOrderState(renderData.curPlayData?.song_id, 1)
        shopCartStore.updateShopCart(renderData.curPlayData?.song_id, 3)
        globalPlayDataStore.updatePlayDataItem({
          ...renderData.curPlayData,
          order_state: 1,
          cart_state: 3,
        })
      }
    }
  })
}

const doRegenerate = () => {
  globalPlayDataStore.doRegenerate(renderData.curPlayData)
}

const handleReport = () => {
  reportDialogVisible.value = true
}

const getAudioUrl = () => {
  if (
    (globalPlayDataStore.curPlayData?.stream_key &&
      appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.currentUrl ==
        getPipeReadableFlowUrl(globalPlayDataStore.curPlayData?.stream_key) &&
      appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.players[
        appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.currentUrl
      ]?.isPlaying) ||
    !globalPlayDataStore.curPlayData?.mp3_url
  ) {
    return getPipeReadableFlowUrl(globalPlayDataStore.curPlayData?.stream_key)
  } else {
    return getObjectStorageFullUrl(globalPlayDataStore.curPlayData?.mp3_url)
  }
}
const initData = () => {
  const url = renderData.url ?? ""
  const isCurrentUrl =
    appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.currentUrl ==
      getPipeReadableFlowUrl(renderData.curPlayData?.stream_key) ||
    appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.currentUrl ==
      getObjectStorageFullUrl(renderData.curPlayData?.mp3_url)

  const currentTime = isCurrentUrl
    ? appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.audio?.currentTime
    : 0
  renderData.curPlayData = globalPlayDataStore.curPlayData
  renderData.isGenerating =
    !/\.[0-9A-Za-z]{1,}$/.test(renderData.curPlayData?.mp3_url ?? "") &&
    renderData.curPlayData?.stream_key
  if (!renderData.curPlayData) return
  renderData.url = getAudioUrl()
  if (renderData.url != url) {
    appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.registerPlayUrl(
      renderData.url,
      {
        duration: renderData.curPlayData?.duration_milliseconds / 1000,
        currentTime: isCurrentUrl ? currentTime : null,
      }
    )
  }
  if (globalPlayDataStore.curPlayData?.duration_milliseconds > 0) {
    renderData.duration =
      (globalPlayDataStore.curPlayData?.duration_milliseconds ?? 0) / 1000
  }
}

watch(
  () => globalPlayDataStore.curPlayData,
  (newVal) => {
    if (!globalPlayDataStore.curPlayData) {
      renderData.curPlayData = null
    } else {
      initData()
    }
  }
)
watch(
  () => globalPlayDataStore.tempToggleStatus,
  (newVal) => {
    renderData.tempToggleStatus = globalPlayDataStore.tempToggleStatus
    if (renderData.tempToggleStatus) {
      refGlobalPlayer.value.changeTempOp(false)
    } else {
      refGlobalPlayer.value.changeTempOp(true)
    }
  }
)

watch(
  () => globalPlayDataStore.isPlaying,
  (isPlaying) => {
    if (renderData.isPlaying != isPlaying) {
      refGlobalPlayer.value.changeOp(isPlaying)
      renderData.isPlaying = isPlaying
    }
  }
)

watch(
  () => globalPlayDataStore.curPlayGroup,
  () => {
    renderData.curPlayGroup = globalPlayDataStore.curPlayGroup
  }
)

onMounted(() => {
 
  initData()
})
</script>
<style lang="scss">
.main-page--pc.main-page--store {
  .bottom-player {
    .audio-item-info {
      width: 0;
      flex: 1;
    }
    .audio-palyer-controls {
      width: max-content;
      min-width: 500px;
      max-width: 600px;
    }
    .audio-palyer-right {
      width: 0;
      flex: 1;
    }
  }
}
.bottom-player {
  display: flex;
  align-items: center;
  padding: 0 16px 0 10px;
  transition: height 0.3s;
  // background: rgba(32, 32, 32, 0.6);
  background: rgba(37, 33, 65, 0.5);
  backdrop-filter: blur(60px);
  .audio-item-cover {
    width: 46px;
    height: 46px;
    border-radius: 4px;
    min-width: 46px;
    margin-right: 10px;
    cursor: unset;
    img {
      width: 100%;
      height: 100%;
      border-radius: 8px;
    }
  }
  .audio-item-info {
    width: 300px;
  }
  .audio-palyer-right {
    width: 300px;

    
  }
  .audio-palyer-right-contennt{
    align-items: center;
    justify-content: end;
  }
  &.bottom-player-show {
    height: 66px;
  }
  &.bottom-player-hide {
    height: 0;
    overflow: hidden;
  }
  .op {
    opacity: 0.3;
  }

  .audio-item-title-version {
    display: flex;
    align-items: center;
    .audio-item-title {
      font-family: HarmonyOS Sans SC;
      font-size: 16px;
      font-weight: 500;
      line-height: 24px;
      color: #ffffff;
      &:hover {
        @include green_text_color;
      }
    }
  }

  .audio-item-decription {
    margin-top: 2px;
    font-family: HarmonyOS Sans SC;
    font-size: 12px;
    font-weight: normal;
    line-height: 16px;
    letter-spacing: 0em;
    color: rgba(255, 255, 255, 0.5);
    text-transform: capitalize;
    align-items: center;
    .audio-item-decription-content {
      flex: 0 1 auto;
    }
    span {
      text-transform: capitalize;
      display: inline-block;
      vertical-align: middle;
    }
    .rotate-loading {
      width: 14px;
      min-width: 14px;
      height: 14px;
      background: url("@/assets/img/loading-mini-white-3x.png");
      background-size: 100% 100%;
      display: inline-block;
      margin: 0 0 0 4px;
    }
  }
  .audio-palyer-controls-box {
    width: 100%;
    max-width: 600px;
    margin: 0 auto;
    min-width: 500px;
  }

  @media screen and (min-width: 1000px) {
    .audio-palyer-controls {
      min-width: 600px !important;
    }
    .audio-palyer-controls-box {
      max-width: 600px;
      min-width: 600px;
    }
  }

  .audio-item-ico-btn {
    height: 40px;
    width: 40px;
    border-radius: 20px;
    &.disabled {
      opacity: 0.5;
      cursor: not-allowed !important;
    }
    &.ico-btn:hover {
      background: rgba(255, 255, 255, 0.1);
    }
    i {
      height: 24px;
      width: 24px;
    }
  }
  .audio-item-like-status {
    i {
      background: url(@/assets/img/praise-ico-white.png);
      background-size: 100% 100%;
    }
    i.like-true {
      background: url(@/assets/img/praise-high-ico-white.png);
      background-size: 100% 100%;
    }
  }
  .audio-item-dislike-status {
    i {
      background: url(@/assets/img/praise-ico-white.png);
      background-size: 100% 100%;
      transform: rotate(180deg);
    }
    i.like-false {
      background: url(@/assets/img/praise-high-ico-white.png);
      background-size: 100% 100%;
    }
  }
  .audio-item-share {
    i {
      background: url(@/assets/img/share-ico.png);
      background-size: 100% 100%;
    }
  }
  .audio-item-buy {
    i.cart-false {
      background: url(@/assets/img/trolley-ico.png);
      background-size: 100% 100%;
    }
    i.cart-true {
      background: url(@/assets/img/trolley-red-ico.png);
      background-size: 100% 100%;
    }
  }
  .audio-item-more {
    i {
      background: url(@/assets/img/more-ico.png);
      background-size: 100% 100%;
    }
  }
  .audio-item-btn,
  .audio-item-ico-btn {
    margin-left: 12px;
  }
}
</style>
